module.exports = __webpack_public_path__ + "img/thomas2.8bf0414e.png";